module.exports = __webpack_public_path__ + "img/gcdp1_4.63cf6648.jpg";